var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"slide-mon",attrs:{"data-url":_vm.landUrl}},[(_vm.cover)?_c('img',{staticClass:"sprite-icons-video fl",attrs:{"src":_vm.cover,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }